<template>
  <div :class="$style['pt-news-detail']" v-loading="loading">
      <div class="news-detail-message">
          <h2>{{newsDetail.title}}</h2>
          <div :class="$style['date-from']">
              <span>{{newsDetail.publish_date}}</span>
              <span>来源：{{newsDetail.from}}</span>
          </div>
          <div v-html="newsDetail.content">
          </div>
      </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-news-detail'

export default {
  name: 'pt-news-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    newsDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  created () {
    console.log(this.newsDetail)
  }
}
</script>

<style module lang="less">
@import "~less/var";
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-news-detail{
    display: flex;
    justify-content: center;
}
:global
.news-detail-message{
    width: 60%;
    ul,p,ol{
        margin-block-start:inherit;
        margin-block-end:inherit;
        padding-inline-start:inherit
    }
    p{
        margin:5px 0
    }
    ul,ol,li{
        list-style-type:inherit
    }
    img{
        max-width: 100%;
        vertical-align: middle;
    }
    // li{
    //     list-style-type:disc
    // }
    h2{
        text-align: center
    }
}
.date-from{
    text-align: center;
    color: @tipTextColor;
    font-size: 13px;
    :global
    span{
        &+span{
            margin-left: 10px
        }
    }
}
</style>
